import { Provider } from '@angular/core';
import { DeliveryRepositoryPort } from '../domain/repositories/delivery.repository.port';
import { DeliveryRepository } from './repositories/delivery.repository';

export const DELIVERY_PROVIDERS: Provider[] = [
  {
    provide: DeliveryRepositoryPort,
    useClass: DeliveryRepository,
  },
];
